import { AbstractCommand } from 'src/models/command';

class AddReceiverGroupMembersCommand extends AbstractCommand {
	override readonly async = false;
	readonly name = 'IFS_Mail_Command_Command_AddReceiverGroupMembersCommand';

	public constructor(groupId: number, emailAddresses: string[]) {
		super();
		this.parameters = {
			emailAddresses: emailAddresses,
			groupId: groupId,
		};
	}
}

export { AddReceiverGroupMembersCommand };
